// src/lib/firebase/config.ts

import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';

// Your Firebase configuration using NEXT_PUBLIC_ prefixes
const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

// A function to initialize and retrieve the Firebase app (Singleton Pattern)
const getFirebaseApp = (): FirebaseApp => {
  if (!getApps().length) {
    return initializeApp(firebaseConfig);
  }
  return getApp();
};

// Initialize the app
const firebaseApp: FirebaseApp = getFirebaseApp();

// Initialize and export Firebase services with your preferred names
const firebaseAuth: Auth = getAuth(firebaseApp);
const firebaseDb: Firestore = getFirestore(firebaseApp);


// Add a check to ensure the project ID is loaded for easier debugging
if (typeof window !== 'undefined') {
  // --- TEMPORARY DEBUGGING ADDITIONS ---
    (window as any)._debugFirebaseConfig = firebaseConfig;
    (window as any)._debugFirebaseAuth = firebaseAuth;
    // --- END TEMPORARY DEBUGGING ADDITIONS ---
  if(!firebaseConfig.projectId){
    console.error(
    'Firebase projectId is not set in your environment variables. ' +
    'Please ensure NEXT_PUBLIC_FIREBASE_PROJECT_ID is defined in your .env.local file.'
  );
  }
  
}

// Export with the new names
export { firebaseAuth as auth, firebaseDb as db };

export default firebaseApp;